import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function NotFound() {
    return (
        <div className="min-h-screen grid place-items-center noise-bg px-6" data-testid="not-found-page">
            <div className="max-w-md rounded-2xl border bg-white p-10 text-center">
                <span className="label-eyebrow">404</span>
                <h1 className="rotary-heading mt-2 text-4xl text-rotary-ink">Page not found</h1>
                <p className="mt-3 text-sm text-muted-foreground">
                    The page you&apos;re looking for isn&apos;t part of the directory.
                </p>
                <Link to="/">
                    <Button
                        className="mt-6 rounded-full bg-rotary-blue text-white hover:bg-rotary-sky"
                        data-testid="not-found-home-btn"
                    >
                        Back to home
                    </Button>
                </Link>
            </div>
        </div>
    );
}
